import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  SectionTitle,
  Showcase,
  Intro,
} from '../../../../components'
import data from './data.json'

import thumbnail from '../../../../images/thumbnail.png'
import thumbnail_with_action from '../../../../images/thumbnail_with_action.png'
import thumbnail_spinner from '../../../../images/thumbnail_spinner.png'
import thumbnail_percent from '../../../../images/thumbnail_percent.png'
import thumbnail_selected from '../../../../images/thumbnail_selected.png'
import thumbnail_hover from '../../../../images/thumbnail_hover.png'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        designOnly="true"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Thumbnails display a small preview image that represents an object.
            The default structure includes an image and a container edged with a
            solid stroke. The button variant allows each image to accommodate an
            additional action.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          title="Standard"
          text='Used for thumbnails without an associated action, or when "select" is the only action. The image becomes the clickable area for the select action.'
        >
          <img src={thumbnail} alt="Standard Thumbnail" />
        </Showcase>

        <Showcase
          title="With Action"
          text='Used for thumbnails with an additional action, such as "Edit" or "Delete". The button becomes its own clickable area, separate from the "Select" action, if applicable.'
        >
          <img src={thumbnail_with_action} alt="Thumbnail with Action" />
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>
          If including an additional action, the button has the same states as
          the general{' '}
          <Link
            to={'/' + data.site + '/components/button/develop'}
            class="link"
          >
            button
          </Link>{' '}
          component. The state for the image are as follows:
        </p>

        <Showcase
          title="Loading, spinner"
          text="Used to indicate that a thumbnail image is loading."
        >
          <img src={thumbnail_spinner} alt="Thumbnail with loading spinner" />
        </Showcase>
        <Showcase
          title="Loading, percentage"
          text="Used to indicate what percentage of a thumbnail image has loaded, when feasible."
        >
          <img
            src={thumbnail_percent}
            alt="Thumbnail with percentage loading"
          />
        </Showcase>
        <Showcase
          title="Selected"
          text="Used to indicate that a thumbnail image is selected, when applicable."
        >
          <img src={thumbnail_selected} alt="Selected thumbnail" />
        </Showcase>
        <Showcase
          title="Hover"
          text="Used on hover to indicate that it's possible to select a given thumbnail image, when applicable."
        >
          <img src={thumbnail_hover} alt="Hover thumbnail" />
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Use <span class="inline__code">l-margin--medium</span> to keep 16px
          around all thumbnails.
        </p>
      </Layout>
    </>
  )
}
